export const LOGIN_LOADING = 'AUTH/LOGIN/LOADING';
export const LOGIN_ERROR = 'AUTH/LOGIN/ERROR';
export const LOGIN_SUCCESS = 'AUTH/LOGIN/SUCCESS';
export const LOGOUT = 'AUTH/LOGOUT';
export const PASSWORD_CHANGE = 'AUTH/PASSWORD_CHANGE';
export const UPDATE_CUSTOMIZATION = 'AUTH/UPDATE_CUSTOMIZATION';
export const COMPANY_CHANGE = 'AUTH/COMPANY_CHANGE';
